import type { DemoKey } from './keys';

export const pt: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Geometria · 3D',
  'panel.figure': 'Figura',
  'panel.dims': 'Dimensões',
  'panel.style': 'Aparência',
  'panel.lines': 'Linhas especiais',
  'style.body': 'Corpo',
  'style.line': 'Linha',
  'style.cut': 'Secção',
  'style.labels': 'Rótulos dos vértices',
  'group.face': 'Diagonais das faces / geratrizes',
  'group.space': 'Diagonais / eixos / medianas',
  'split.label': 'Secção',
  'btn.animate': 'Animar',
  'btn.reset': 'Reiniciar',
  'hint.line1': 'Arrastar para girar · Rolar para zoom',
  'hint.line2': 'Clique numa linha para a selecionar',
  'fig.cuboid': 'Paralelepípedo',
  'fig.cube': 'Cubo',
  'fig.triPrism': 'Prisma triangular',
  'fig.hexPrism': 'Prisma hexagonal',
  'fig.tetrahedron': 'Tetraedro',
  'fig.squarePyramid': 'Pirâmide quadrada',
  'fig.cylinder': 'Cilindro',
  'fig.cone': 'Cone',
  'fig.sphere': 'Esfera',
  'fig.frustumPyramid': 'Tronco de pirâmide',
  'fig.frustumCone': 'Tronco de cone',
  'dim.length': 'comprimento',
  'dim.width': 'largura',
  'dim.height': 'altura',
  'dim.side': 'lado',
  'dim.radius': 'raio',
  'dim.r1': 'raio inferior',
  'dim.r2': 'raio superior',
  'dim.sideBase': 'lado base',
  'dim.sideTop': 'lado topo',
  'info.face': 'face',
  'info.center': 'pelo centro',
  'info.diagonal': 'diagonal',
  'info.axial': 'diagonal axial',
  'info.diameter': 'diâmetro',
  'info.generator': 'geratriz',
  'info.axis': 'eixo',
  'info.height': 'altura',
  'info.median': 'mediana',
  'info.apothem': 'apótema',
  'info.diameterBase': 'diâmetro base',
  'info.diameterTop': 'diâmetro topo',
};
